export function taskSecondaryCount(parts: {
  attachments: number;
  files: number;
  comments: number;
}): number {
  return parts.attachments + parts.files + parts.comments;
}

export function taskSecondaryAccordionLabel(count: number): string {
  const base = 'Pièces, fichiers et commentaires';
  return count > 0 ? `${base} (${count})` : base;
}
